import { BrowserOptions } from '@amplitude/analytics-types';

import { Ampli, Environment, IdentifyProperties } from './ampli';
import { AmplitudeGTMPlugin } from './AmplitudeGTMPlugin';

let ampli: Ampli = new Ampli();

/**
 * Initialises the tracking configuration.
 */
function initialise({
  environment,
  disabled,
  clientConfiguration,
}: {
  environment: Environment;
  disabled?: boolean;
  clientConfiguration?: BrowserOptions;
}) {
  const configuration: BrowserOptions = clientConfiguration || {
    defaultTracking: {
      pageViews: {
        trackHistoryChanges: 'all',
      },
    },
  };

  ampli.load({
    environment,
    disabled,
    client: { configuration },
  });
  ampli.client.add(new AmplitudeGTMPlugin());
}

/**
 * Identifies the customer using their state key.
 */
function identifyCustomer({
  stateKey,
  country,
  isImpersonating,
  ...otherProperties
}: {
  stateKey: string;
  country: 'UK' | 'DE';
  isImpersonating: boolean;
} & Partial<IdentifyProperties>) {
  ampli.identify(stateKey, {
    ...otherProperties,
    impersonating: isImpersonating,
    site: country,
    user_type: 'customer',
  });
}

/**
 * Identifies the introducer using their introducer id.
 */
function identifyIntroducer({
  introducerId,
  country,
  isImpersonating,
  ...otherProperties
}: {
  introducerId: string;
  country: 'UK' | 'DE';
  isImpersonating: boolean;
} & Partial<IdentifyProperties>) {
  ampli.identify(introducerId, {
    ...otherProperties,
    impersonating: isImpersonating,
    site: country,
    user_type: 'introducer',
  });
}

function identifyStaff({
  staffId,
  country,
  ...otherProperties
}: {
  staffId: string;
  country: 'UK' | 'DE';
} & Partial<IdentifyProperties>) {
  ampli.identify(staffId, {
    ...otherProperties,
    site: country,
    user_type: 'staff',
  });
}

/**
 * Resets the tracking configuration.
 * For testing purposes only.
 */
function reset() {
  ampli = new Ampli();
}

export default {
  initialise,
  identifyCustomer,
  identifyIntroducer,
  identifyStaff,
  ampli,
  reset,
};
